export default "__VITE_ASSET__BxNyseOt__"